function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  viewBox: "0 0 41 40"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(8 8)"
}, React.createElement("path", {
  d: "M2.5 16a1.87 1.87 0 01-1.555-.832A2.655 2.655 0 01.5 13.7V11a3 3 0 01.6-1.8l1.8-2.4A2 2 0 014.5 6H11c.644 0 1.266.236 1.747.664L16.5 10l5.02.717A2.306 2.306 0 0123.5 13v2a1 1 0 01-1 1h-2m-4 0h-10"
}), React.createElement("circle", {
  cx: "18.5",
  cy: "16",
  r: "2"
}), React.createElement("circle", {
  cx: "4.5",
  cy: "16",
  r: "2"
}), React.createElement("path", {
  d: "M16.5 10H.672M9.5 16V6m-4 0l-1 4m8 2h-1m-5 0h-1m-5 0h1m20 1h2"
}))));